import { render, staticRenderFns } from "./EditDisplayName.vue?vue&type=template&id=2f4531e5&scoped=true&"
import script from "./EditDisplayName.vue?vue&type=script&lang=js&"
export * from "./EditDisplayName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4531e5",
  null
  
)

export default component.exports